import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import CalendarView from "../CalendarView/CalendarView";
import ImportantEvents from "../ImportantEvents/ImportantEvents";
import AbsenceList from "../AbsenceList/AbsenceList";
import AbsenceRequests from "../AbsenceRequests/AbsenceRequests";
import EventModal from "../CreateEvent/CreateEvent";
import ViewEditEvent from "../ViewEditEvent/ViewEditEvent";
import AddDesignatedModal from "../AddDesignatedModal/AddDesignatedModal";
import Tomas_Photo from "../../../../assets/icons/Tomas_photo.svg";

const ManageUserAbsences = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newEventTitle, setNewEventTitle] = useState("");
  const [newEventDate, setNewEventDate] = useState("");
  const [priorityValue, setPriorityValue] = useState("");
  const [typeValue, setTypeValue] = useState("");
  const [allDay, setAllDay] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [designatedModalOpen, setDesignatedModalOpen] = useState(false);
  const [selectedDesignados, setSelectedDesignados] = useState([]);

  const userList = [
    { id: "user1", name: "João", avatar: Tomas_Photo },
    { id: "user2", name: "Maria", avatar: Tomas_Photo },
    { id: "user3", name: "Carlos", avatar: Tomas_Photo },
  ];

  const priorityOptions = [
    { value: "high", label: "Alta" },
    { value: "medium", label: "Média" },
    { value: "low", label: "Baixa" },
  ];

  const typeOptions = [
    { value: "meeting", label: "Reunião" },
    { value: "holiday", label: "Feriado" },
    { value: "deadline", label: "Prazo" },
  ];

  const priorityColors = {
    high: "#dc3545",
    medium: "#ffc107",
    low: "#28a745",
  };

  const onEventSave = (updatedEvent) => {
    console.log("Evento guardado:", updatedEvent);
    setEvents((prevEvents) =>
      prevEvents.map((evt) => (evt.id === updatedEvent.id ? updatedEvent : evt))
    );
    setViewModalOpen(false);
  };

  const handleOpenDesignatedModal = () => {
    setDesignatedModalOpen(true);
  };

  const handleCloseDesignatedModal = () => {
    setDesignatedModalOpen(false);
  };

  const handleSaveDesignados = (designados) => {
    console.log("Designados recebidos do modal:", designados);
    setSelectedDesignados(designados);
    setDesignatedModalOpen(false);
  };

  const handleCreateEvent = () => {
    if (!newEventTitle || !newEventDate) {
      alert("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    const parsedDate = allDay ? `${newEventDate}T00:00` : newEventDate;

    const novoEvento = {
      id: Date.now(),
      title: newEventTitle,
      start: parsedDate,
      allDay,
      color: priorityColors[priorityValue] || "#28a745",
      extendedProps: {
        type: typeValue,
        priority: priorityValue,
        designados: selectedDesignados,
      },
    };

    setEvents((prevEvents) => [...prevEvents, novoEvento]);
    resetModalState();
    setShowModal(false);
  };

  const resetModalState = () => {
    setNewEventTitle("");
    setNewEventDate("");
    setPriorityValue("");
    setTypeValue("");
    setAllDay(false);
    setSelectedDesignados([]);
  };

  useEffect(() => {
    const storedEvents = localStorage.getItem("events");
    if (storedEvents) {
      setEvents(JSON.parse(storedEvents));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("events", JSON.stringify(events));
  }, [events]);

  return (
    <Container
      fluid
      className="p-4"
      style={{ minHeight: "100vh", backgroundColor: "#1B0F5B" }}
    >
      <Row>
        <Col md={9}>
          <CalendarView
            events={events}
            onEventClick={(clickInfo) => {
              setSelectedEvent(clickInfo.event);
              setViewModalOpen(true);
            }}
            onEventDrop={(info) => {
              const updatedEvent = {
                id: info.event.id,
                title: info.event.title,
                start: info.event.start.toISOString(),
                allDay: info.event.allDay,
                color:
                  info.event.backgroundColor ||
                  priorityColors[info.event.extendedProps?.priority] ||
                  "#28a745",
                extendedProps: {
                  ...info.event.extendedProps,
                },
              };

              setEvents((prevEvents) =>
                prevEvents.map((event) =>
                  event.id.toString() === updatedEvent.id.toString()
                    ? updatedEvent
                    : event
                )
              );
            }}
          />
        </Col>
        <Col md={3}>
          <div className="d-flex flex-column align-items-start mb-3">
            <Button
              variant="primary"
              onClick={() => {
                resetModalState();
                setShowModal(true);
              }}
            >
              Criar Evento
            </Button>
          </div>
          <ImportantEvents events={events} selectedEvent={selectedEvent} />
        </Col>
      </Row>

      <Row className="mt-2">
        <Col md={6}>
          <AbsenceList absences={[]} />
        </Col>
        <Col md={6}>
          <AbsenceRequests requests={[]} />
        </Col>
      </Row>

      <EventModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onCreate={handleCreateEvent}
        titleValue={newEventTitle}
        onTitleChange={(e) => setNewEventTitle(e.target.value)}
        dateValue={newEventDate}
        onDateChange={(e) => setNewEventDate(e.target.value)}
        typeValue={typeValue}
        onTypeChange={(e) => setTypeValue(e.target.value)}
        priorityValue={priorityValue}
        onPriorityChange={(e) => setPriorityValue(e.target.value)}
        allDay={allDay}
        setAllDay={setAllDay}
        typeOptions={typeOptions}
        priorityOptions={priorityOptions}
        userList={userList}
        selectedDesignados={selectedDesignados}
        onAddDesignatedClick={handleOpenDesignatedModal}
      />
      <AddDesignatedModal
        show={designatedModalOpen}
        onClose={handleCloseDesignatedModal}
        userList={userList}
        onSave={handleSaveDesignados}
        selectedDesignados={selectedDesignados}
      />
      <ViewEditEvent
        show={viewModalOpen}
        event={selectedEvent}
        onClose={() => setViewModalOpen(false)}
        onSave={onEventSave}
      />
    </Container>
  );
};

export default ManageUserAbsences;
